import { AdminArtist } from 'static/classes/Artist';
import { LANGUAGES } from 'shared/common/constants';
import { ARTIST_STATUSES } from 'static/common/constants';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function AllArtistsViewModel(data) {
    var self = this;
    self.type = "AllArtistsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = async () => {
        console.log('init all artists');

        if (self.offset() == undefined) {
            self.offset(0);
        }
        if (self.limit() == undefined) {
            self.limit(10);
        }
        const languages = await self.lookup_used_languages();
        const instruments = await self.lookup_used_instruments();
        ko.utils.arrayPushAll(self.spoken_languages_options, LANGUAGES.filter(a => languages.spoken_languages?.some(b => a.language === b)));
        ko.utils.arrayPushAll(self.song_languages_options, LANGUAGES.filter(a => languages.song_languages?.some(b => a.language === b)));
        ko.utils.arrayPushAll(self.instruments_options, instruments);
        if (!self.initialized()) {
            console.log('look up artists');
            
            self.lookup_artists().then(function () {
                console.log('done looking up artists');
                self.initialized(true);
            })
        };
    }

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable();

    self.artists = ko.observableArray([]);

    self.error = ko.observable();
    self.person_name_search = ko.observable();

    self.artist_actions = ko.observableArray([
        { title: 'create', value: 'create' },
        { title: 'publish', value: 'publish' },
        { title: 'apply to be pro', value: 'apply to be pro' },
        { title: 'admin approves', value: 'admin approves' },
        { title: 'admin declines', value: 'admin declines' },
        { title: 'artist paid', value: 'artist paid' },
        { title: 'renewal needed', value: 'renewal needed' },
        { title: 'admin pause (email)', value: 'pause' },
        { title: 'artist self pause', value: 'artist pause' },
        { title: 'delete', value: 'remove' },
    ]);

    self.artist_statuses = ko.observableArray(ARTIST_STATUSES);


    self.admin_ranking_options = ko.observableArray([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
    self.languages_options = ko.observableArray(LANGUAGES);
    self.spoken_languages_options = ko.observableArray([]);
    self.song_languages_options = ko.observableArray([]);
    self.instruments_options = ko.observableArray([]);

    self.filter_location = ko.observable();
    self.filter_location_radius = ko.observable(80);
    self.filter_artist_action = ko.observable();
    self.filter_spoken_language = ko.observable();
    self.filter_song_language = ko.observable();
    self.filter_instrument = ko.observableArray([]);
    self.filter_video_messages = ko.observable(false);
    self.filter_online_concert = ko.observable(false);
    self.filter_show_only_published = ko.observable(true);
    self.filter_video_quality_rating = ko.observable(0);
    self.filter_corporate_behaviour_rating = ko.observable(0);
    self.filter_admin_ranking = ko.observable(0);

    self.order_by_column = ko.observable('inserted');
    self.sort_desc = ko.observable(true);

    self.selected_artist_info = ko.observable(new AdminArtist({}));
    self.set_selected_artist_info = function (artist, showModal) {
        self.selected_artist_info(artist);
        if (showModal) {
            setDataAndShowDetailsModal(artist, 'artist');
        }
    }
    self.search_click = function () {

        //console.log('order column is ', self.order_by_column());
        self.offset(0);
        self.lookup_artists().then(function () {
            console.log('done looking up artists from search click');
        });
        return false;
    }

    self.full_text_search_click = function () {
        self.offset(0);
        self.lookup_artists().then(function () {
            console.log('done looking up artists from search click');
        });
        return false;
    }
    self.search_name = ko.observable();
    self.full_text_search = ko.observable();
    self.full_text_search_lang = ko.observable();

    self.get_login_link = function (person) {
        person.get_login_link('/manage/artist/edit/basic');
    }

    /* For now, since we want order -- just use static
    self.lookup_artist_actions = function(){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/artist-actions',
            type: 'GET',

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                self.artist_actions(data.artist_actions);
            },

            error: function (data) {
                self.error(data.statusText);
            }
        });
    }*/

    self.lookup_used_languages = async () => {
        const response = await fetch(self.rootvm.web_host + '/api/admin/used-languages', { headers: { 'Accept': 'application/json' }});
        const data = await response.json();
        if (data.success) {
            return data.languages
        } else {
            throw new Error(data.message)
        }
    };

    self.lookup_used_instruments = async () => {
        const response = await fetch(self.rootvm.web_host + '/api/instruments', { headers: { 'Accept': 'application/json' }});
        const data = await response.json();
        if (data.success) {
            return data.instruments
        } else {
            throw new Error(data.message)
        }
    };

    self.lookup_artists = function () {
        self.rootvm.is_busy(true);

        if(self.filter_admin_ranking() == undefined){
            self.filter_admin_ranking(0);
        }

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/artists',
            type: 'GET',
            data: {
                limit: self.limit(),
                offset: self.offset(),
                search: self.search_name(),
                longitude: self.filter_location()?.type === 'Location' ? self.filter_location().longitude() : '',
                latitude: self.filter_location()?.type === 'Location' ? self.filter_location().latitude() : '',
                radius: self.filter_location()?.type === 'Location' ? self.filter_location_radius() : '',
                artist_action: self.filter_artist_action(),
                show_only_published: self.filter_show_only_published(),
                spoken_language: self.filter_spoken_language(),
                song_language: self.filter_song_language(),
                instrument: self.filter_instrument(),
                online_concert: self.filter_online_concert(),
                video_messages: self.filter_video_messages(),
                order_by_column: self.order_by_column(),
                video_quality: self.filter_video_quality_rating(),
                corporate_behaviour: self.filter_corporate_behaviour_rating(),
                admin_ranking: self.filter_admin_ranking(),
                sort_desc: self.sort_desc(),
                full_text: self.full_text_search(),
                full_text_lang: self.full_text_search_lang()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.artists(data.artists?.map((a) => {
                    a.rootvm = self.rootvm
                    return new AdminArtist(a);
                }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function () {
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lower_count_label = ko.computed(function () {
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function () {
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count()) {
            return self.filtered_count();
        }
        else {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function () {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {
        if (self.rootvm.is_busy()) {
            return false;
        }

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));
        if (self.offset() < 0) {
            self.offset(0);
        }

        self.lookup_artists().then(function () {
            pager.navigate("#community/artists"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
                + "&filter_admin_ranking="
                + self.filter_admin_ranking()

            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()) {
            return false;
        }

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_artists().then(function () {
            pager.navigate("#community/artists"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
                + "&filter_admin_ranking="
                + self.filter_admin_ranking()
            );
        });
    };

    self.toggle_online_concert = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/toggle-online-concert'
        const request = new Request(url, {
            body: JSON.stringify({
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.online_concert(data.online_concert);
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }
    self.set_video_quality = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/set-video-quality'
        const request = new Request(url, {
            body: JSON.stringify({
                video_quality: artist.new_video_quality(),
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.video_quality(data.video_quality);
            artist.new_video_quality(undefined)
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }
    self.set_corporate_behaviour = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/set-corporate-behaviour'
        const request = new Request(url, {
            body: JSON.stringify({
                corporate_behaviour: artist.new_corporate_behaviour(),
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.corporate_behaviour(data.corporate_behaviour);
            artist.new_corporate_behaviour(undefined)
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }
    // spoken language
    self.delete_spoken_language = async (language, artist) => {
        const url = scvm.web_host + '/api/admin/artist/delete-spoken-language'
        const request = new Request(url, {
            body: JSON.stringify({
                language: language,
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.spoken_languages.remove(language);
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    };
    self.add_new_spoken_language = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/add-spoken-language'
        const request = new Request(url, {
            body: JSON.stringify({
                language: artist.new_spoken_language(),
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.spoken_languages.push(artist.new_spoken_language());
            artist.new_spoken_language(undefined)
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }
    // song language
    self.delete_song_language = async (language, artist) => {
        const url = scvm.web_host + '/api/admin/artist/delete-song-language'
        const request = new Request(url, {
            body: JSON.stringify({
                language: language,
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.song_languages.remove(language);
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    };
    self.add_new_song_language = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/add-song-language'
        const request = new Request(url, {
            body: JSON.stringify({
                language: artist.new_song_language(),
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.song_languages.push(artist.new_song_language());
            artist.new_song_language(null)
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }
    // instruments
    self.delete_instrument = async (instrument, artist) => {
        const url = scvm.web_host + '/api/admin/artist/delete-instrument'
        const request = new Request(url, {
            body: JSON.stringify({
                instrument: instrument,
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.instruments.remove(instrument);
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    };
    self.add_new_instrument = async (artist) => {
        const url = scvm.web_host + '/api/admin/artist/add-instrument'
        const request = new Request(url, {
            body: JSON.stringify({
                instrument: artist.new_instrument(),
                artist_uuid: artist.artist_uuid()
            }),
            processData: false,
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json; charset=utf-8'
            })
        });
        const response = await fetch(request);
        const data = await response.json();
        if (data.success) {
            artist.instruments.push(artist.new_instrument());
            artist.new_instrument(null)
        } else {
            console.error(data.message);
            throw new Error(data.message)
        }
    }

    // Table columns visibility
    self.show_location_col = ko.observable(true);
    self.show_state_col = ko.observable(false);
    self.show_ranking_col = ko.observable(true);
    self.show_recommendation_text_col = ko.observable(false);
    self.show_fees_col = ko.observable(true);
    self.show_onlineConcert_col = ko.observable(true);
    self.show_corporateBehavoiur_col = ko.observable(true);
    self.show_videoQuality_col = ko.observable(true);
    self.show_videoMsg_col = ko.observable(true);
    self.show_spokenLang_col = ko.observable(true);
    self.show_songLang_col = ko.observable(true);
    self.show_instruments_col = ko.observable(true);
    self.show_sections_col = ko.observable(false);
    self.show_inserted_col = ko.observable(true);
    self.show_comment_col = ko.observable(true);
    self.show_bypass_col = ko.observable(true);

    self.admin_view = ko.observable(false);
    self.admin_view.subscribe((newValue) => {
        if (newValue) {
            self.show_location_col(false);
            self.show_state_col(true);
            self.show_ranking_col(true);
            self.show_recommendation_text_col(true);
            self.show_fees_col(true);
            self.show_onlineConcert_col(false);
            self.show_corporateBehavoiur_col(false);
            self.show_videoQuality_col(false);
            self.show_videoMsg_col(false);
            self.show_spokenLang_col(true);
            self.show_songLang_col(false);
            self.show_instruments_col(false);
            self.show_sections_col(true);
            self.show_inserted_col(true);
            self.show_comment_col(true);
            self.show_bypass_col(true);

            self.filter_show_only_published(false);
        } else {
            self.show_location_col(true);
            self.show_state_col(false);
            self.show_ranking_col(true);
            self.show_recommendation_text_col(false);
            self.show_fees_col(true);
            self.show_onlineConcert_col(true);
            self.show_corporateBehavoiur_col(true);
            self.show_videoQuality_col(true);
            self.show_videoMsg_col(true);
            self.show_spokenLang_col(true);
            self.show_songLang_col(true);
            self.show_instruments_col(true);
            self.show_sections_col(false);
            self.show_inserted_col(true);
            self.show_comment_col(true);
            self.show_bypass_col(true);

            self.filter_artist_action(null);
            self.filter_show_only_published(true);
        }
        self.search_click();
    });
};
